export default "__VITE_ASSET__Cz2yd1NU__"